/* Start mega sub menu */
$(function () {
    var $megaMenu = $('.megaMenu');
    var flag;

    $megaMenu.on('mouseover', function(event){
        $megaMenu.show();
        clearTimeout(flag);
    });
    $megaMenu.on('mouseout', function(event){
        flag = setTimeout(function () {
            $megaMenu.hide();
        },150);
    });

    $('.menu-list li').each(function () {
        var $el = $(this);
        var index = $el.index();
        var $megaLi = $('.megaMenu__list > li').eq(index);
        if (!$megaLi.children().length) {
            return;
        }

        $(this).find('a').on('mouseover', function(event){
            $megaLi
                .show()
                .siblings()
                .hide();
            $megaMenu.show();
            clearTimeout(flag);
        });
        $(this).find('a').on('mouseout', function(event){
            flag = setTimeout(function () {
                $megaMenu.hide();
            },150);
        });
    });

    setLeftMargin();
    $(window).resize(setLeftMargin);


    function setLeftMargin() {
        $('.menu-list li').each(function () {
            var $el = $(this);
            var index = $el.index();
            var $megaUl = $('.megaMenu__list > li').eq(index).find('ul');
            if (!$megaUl.length) {
                return;
            }

            var leftMargin = $el.find('a').offset().left + 15;
            $megaUl.css({'margin-left': leftMargin});
        });
    }
});
/* End mega sub menu */


/* Start product tabs */
$(function () {
    $('.prTabs__title').click(function (e) {
        e.preventDefault();

        var $title = $(this);
        $title.addClass('prTabs__title--active')
            .siblings()
            .removeClass('prTabs__title--active');

        var $item = $('.prTabs__item').eq($(this).index());
        $item.addClass('prTabs__item--active')
            .siblings()
            .removeClass('prTabs__item--active');
    });
});
/* End product tabs */



function initFancybox() {
    Fancybox.defaults.clickOutside = 'zoom';
    Fancybox.defaults.clickSlide = 'zoom';
    Fancybox.defaults.loop = true;
    Fancybox.defaults.idleTime = false;
    Fancybox.defaults.baseTpl =
        '<div class="fancybox-container" role="dialog" tabindex="-1">' +
        '<div class="fancybox-bg"></div>' +
        '<div class="fancybox-inner">' +
        '<div class="fancybox-infobar"><span data-fancybox-index></span>&nbsp;/&nbsp;<span data-fancybox-count></span></div>' +
        '<div class="fancybox-toolbar">{{buttons}}</div>' +
        '<div class="fancybox-navigation">{{arrows}}</div>' +
        '<div class="fancybox-stage"></div>' +
        '<div class="fancybox-caption"><div class=""fancybox-caption__body"></div></div>' +
        '</div>' +
        '<button type="button" data-fancybox-close="" class="fancybox-button fancybox-close-small" title="Close"></button>' +
        '</div>';

    $(function () {
        FancyboxInit.call($('[data-fancybox="images"]'), {
            showCloseButton: true,
            buttons : [
                'slideShow',
                'share',
                'zoom',
                'fullScreen',
                'close'
            ],
            afterLoad : function(instance, current) {
                var pixelRatio = window.devicePixelRatio || 1;

                if ( pixelRatio > 1.5 ) {
                    current.width  = current.width  / pixelRatio;
                    current.height = current.height / pixelRatio;
                }
            }
        });

        $('.prSizeChartLink--mobile, .prSizeChartLink--desktop')
            .click(function (e) {
                e.preventDefault();
                Fancybox.open({
                    src: '#productSizeChart',
                    type: 'inline'
                });
            });
    });
}


function initSlick () {
    $(function () {
        $('.product-slider').slick({
            dots:true,
            arrows:true,
            fade: true,
            lazyLoad: 'ondemand',
            responsive: [
                {
                    breakpoint: 767,
                    settings: {
                        arrows:false
                    }
                }
            ]
        });
    });
}